/* eslint-disable max-len */
import {
  AccessTime,
  // KeyboardDoubleArrowRight,
  Person,
  // QuestionMark,
} from '@mui/icons-material';
import { actionNotificationLabelSwitch } from '../actions/actionLabels';
// import { stepDisplayProps } from '../stepsInterpolation/stepDisplayProps';
// import SvgComponent from '../../components/SVG/SvgComponent';

const MessageHTML = ({
  item,
}: // , steps
any) => {
  // const targetNewStepProps = stepDisplayProps(steps, item?.newStep);
  // const targetPrevStepProps = stepDisplayProps(steps, item?.stepId);
  return (
    <>
      <span className="spanSocketToastUser">
        <Person />
        {item?.username}
      </span>
      <span className="spanSocketToastMex">
        <svg
          width="1px"
          height="1px"
          version="1.1"
          id="_x32_"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 512 512"
          xmlSpace="preserve"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <g>
              <path d="M468.342,117.058c-13.04-15.571-31.47-26.466-52.439-29.857l-1.323-0.221l1.338,0.228 c-5.436-0.897-10.758-1.315-15.921-1.315c-11.8-0.008-22.81,2.228-32.564,6.128c-14.651,5.854-26.444,15.336-34.716,26.475 c-0.038,0.053-0.076,0.106-0.107,0.152c-7.146-13.602-12.264-28.952-12.264-42.616c0-40.267,54.166-36.45,33.333-76.032H155.767 c-20.833,39.582,33.332,35.765,33.332,76.032c0,12.994-4.638,27.539-11.237,40.639c-5.292-6.706-11.876-12.72-19.617-17.662 c-12.659-8.068-28.527-13.138-46.242-13.116c-5.163,0-10.485,0.418-15.921,1.315h-0.027l0.05-0.007 c-0.03,0.007-0.053,0.007-0.084,0.007l-1.361,0.221l1.255-0.198c-20.894,3.421-39.256,14.294-52.257,29.827 c-13.07,15.549-20.833,35.888-20.818,57.929c0,10.394,1.726,21.115,5.3,31.82c5.353,16.065,14.879,32.009,28.778,46.965 c9.048,9.724,19.958,19.031,32.815,27.805c8.668,73.272,103.396,115.69,106.772,159.546c0.729,9.587-6.63,34.138-27.007,43.87 c0,0-15.176,27.007,8.44,27.007h153.57c23.616,0,8.432-27.007,8.432-27.007c-20.369-9.732-27.736-34.283-26.998-43.87 c3.346-43.468,96.447-85.537,106.513-157.646c20.841-13.777,36.716-28.968,48.075-44.958c7.337-10.34,12.766-21.007,16.332-31.713 c3.581-10.705,5.3-21.426,5.3-31.82C489.175,152.946,481.412,132.607,468.342,117.058z M147.434,154.17 c-31.007,25.57-48.167,50.843-54.918,82.069c-7.163-6.508-12.942-13.04-17.465-19.41c-5.345-7.551-9.01-14.895-11.352-21.897 c-2.334-7.003-3.353-13.671-3.361-19.944c0.016-13.274,4.577-24.9,12.052-33.834c7.497-8.918,17.814-15,29.713-16.939h0.008 c3.482-0.563,6.774-0.821,9.892-0.821c7.116,0,13.298,1.315,18.665,3.459c8.052,3.194,14.348,8.386,18.499,13.982 c2.068,2.79,3.589,5.665,4.539,8.31c0.046,0.122,0.076,0.244,0.122,0.365C151.608,151.448,149.464,153.029,147.434,154.17z M448.3,194.931c-3.513,10.492-9.998,21.798-20.688,33.309c-3.064,3.308-6.501,6.623-10.287,9.93 c-6.455-32.124-23.676-57.898-55.314-84c-1.399-0.79-2.851-1.795-4.341-2.965c0.403-1.498,0.965-3.103,1.764-4.767 c2.646-5.55,7.611-11.458,14.446-15.785c6.858-4.334,15.466-7.246,26.117-7.261c3.118,0,6.41,0.258,9.892,0.821l-1.429-0.236 l1.445,0.236c11.891,1.939,22.209,8.021,29.706,16.939c7.474,8.934,12.036,20.56,12.052,33.834 C451.661,181.26,450.634,187.928,448.3,194.931z"></path>
            </g>
          </g>
        </svg>
        {item?.code}
      </span>
      <div className="props1divSocketToastMex">
        <div className="propsSocketToastMex">
          <span className="keySocketToastMex">Azione ·</span>
          <span className="valueSocketToastMex">{actionNotificationLabelSwitch(item?.actionExec)}</span>
        </div>
        <div className="propsSocketToastMex">
          <span className="keySocketToastMex">Status ·</span>
          <span className="valueSocketToastMex">{item?.newStatus}</span>
        </div>
      </div>

      {/* non si può far vedere perchè chi non vede determinati step non vedrebbe la label */}
      {/* <div style={{ display: 'flex' }}>
          <span className="keySocketToastMex">Ora in</span>
          <span className="valueSocketToastMex">
            {targetNewStepProps?.stepLabel
              ? targetNewStepProps?.stepLabel
              : 'N/D'}
          </span>
        </div> */}

      {/* icone dinamiche da .. a ..,  non funzionante perchè solo gli interessati vedono gli step */}
      {/* <div
        style={{
          display: 'flex',
          gap: '0.8em',
          marginTop: '8px',
          marginLeft: '15px',
          
        }}
      >
        <div style={{ width: '45px', backgroundColor: 'white', borderRadius: '20px', padding: '5px', display: 'flex', justifyContent: 'center' }}>
          {targetPrevStepProps?.svgProps ? <SvgComponent svgProps={targetPrevStepProps?.svgProps} /> : <QuestionMark/>}
        </div>

        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}><KeyboardDoubleArrowRight style={{fill: 'white'}}/></div>

        <div style={{ width: '45px', backgroundColor: 'white', borderRadius: '20px', padding: '5px', display: 'flex', justifyContent: 'center' }}>
          {targetNewStepProps?.svgProps ? <SvgComponent svgProps={targetNewStepProps?.svgProps} /> : <QuestionMark/>}
        </div>
      </div> */}

      <span className="socketToastDate">
        <AccessTime />
        {item?.date}
      </span>
    </>
  );
};

export default MessageHTML;
